import React from 'react';
import { observer } from 'mobx-react';

import { Collapse, Checkbox, Switch, List } from 'antd';

import { Cerchio, CieloTerra, Porzioni, Stella, Quadrato, Rombo, Direct, Triangolo, Core, Development, Opportunistic, Trophy, Valueadd, HSct, HSporz, PinGen, PinComp, PinFoto } from "./CustomIcons";

import QueueAnim from 'rc-queue-anim';

const data = [
  {
    title: 'BASTIA 49',
    description: 'Milano',
    link: 'http://www.prova2.com',
  },
  {
    title: 'BATTISTI 15',
    description: 'Milano',
    link: 'http://www.prova3.com',
  },
  {
    title: 'BIXIO 29',
    description: 'Milano',
    link: 'http://www.prova4.com',
  },
  {
    title: 'BRAMANTE 65',
    description: 'Milano',
    link: 'http://www.prova5.com',
  },
];


@observer
class FilterPanel extends React.Component {
	getCollapseHeader = (groupKey, text) => {
		return (
			<div>{text}
				<Switch size="small" className="color-switch" onClick={
					(checked, e) => { e.stopPropagation(); this.props.stateStore.setColorGroup(groupKey, checked); } 
				} checkedChildren="colore" unCheckedChildren="colore"
				checked={this.props.stateStore.colorGroup === groupKey} />
			</div>
		);
		
	};

	getFullItemLegend = (groupKey, defaultLegendItem, textLabel, seqNum) => {
		if (this.props.stateStore.colorGroup === groupKey){
			return <span><Cerchio className={`color-${String(seqNum).padStart(2, '0')}`} />{defaultLegendItem}{textLabel}</span>
		}
		else {
			return <span>{defaultLegendItem}{textLabel}</span>;
		}
	};

	getAllGroupCheckboxProps = (groupKey) => {
		let checkedList = (this.props.stateStore.filters[groupKey] ?
				this.props.stateStore.filters[groupKey] : []);
		return {
			onChange: (e) => {
				this.props.stateStore.setAllGroupFilter(groupKey, e.target.checked);
				this.props.stateStore.setGroupFilter(groupKey, e.target.checked ?
					this.props.stateStore.COLUMNS_AND_VALUES_MAP[groupKey].map(item => item.value)
					: []
				);
			}
			,indeterminate: (!!checkedList.length && checkedList.length != this.props.stateStore.COLUMNS_AND_VALUES_MAP[groupKey].length)
			,checked: (this.props.stateStore.allFilterGroups.indexOf(groupKey) !== -1)
		}
	};

	getCheckboxGroupFilterProps = (groupKey) => ({
		options: this.getFilterGroupOptionsByGroupKey(groupKey)
		,onChange: (checkedList) => {
			console.log('yeee', checkedList);
			this.props.stateStore.setGroupFilter(groupKey, checkedList);
			this.props.stateStore.setAllGroupFilter(groupKey, (checkedList.length === this.props.stateStore.COLUMNS_AND_VALUES_MAP[groupKey].length));
		}
		,value: (this.props.stateStore.filters[groupKey] ? this.props.stateStore.filters[groupKey] : [])
	});

	getFilterGroupOptionsByGroupKey = (groupKey) => (
		this.props.stateStore.COLUMNS_AND_VALUES_MAP[groupKey].map( (item, ndx) => ({
			value: item.value
			,label: this.getFullItemLegend(groupKey, item.icon, item.label, ndx+1)
		}) )
	)

	render() {
		return (<QueueAnim duration={250} delay={[250,0]}>
		{ this.props.stateStore.filterPanelShowList ? (
			<div className="search-results" key="search-results">
				 <List
					itemLayout="horizontal"
					dataSource={data}
					renderItem={ item => (
						<a href={item.link}>
							<List.Item>
								<List.Item.Meta title={item.title} description={item.description} />
							</List.Item>
						</a>
					)}
				  />
			</div>
		) : (
			<Collapse key="filter-form" expandIconPosition="left" bordered={false} defaultActiveKey={['macroCatC','macroCatB','strategy','saleStrategy','destination']}>
				<Collapse.Panel header={this.getCollapseHeader('macroCatC', 'Tipologia Immobile')} key="macroCatC">
					<Checkbox.Group {...this.getCheckboxGroupFilterProps('macroCatC')} />
				</Collapse.Panel>
				<Collapse.Panel header={this.getCollapseHeader('macroCatB', 'Strategia')} key="macroCatB">
					<Checkbox {...this.getAllGroupCheckboxProps('macroCatB')}>Tutti</Checkbox><br/>
					<Checkbox.Group {...this.getCheckboxGroupFilterProps('macroCatB')} />
				</Collapse.Panel>
				<Collapse.Panel header={this.getCollapseHeader('strategy', 'Cluster')} key="strategy">
					<Checkbox {...this.getAllGroupCheckboxProps('strategy')}>Tutti</Checkbox><br/>
					<Checkbox.Group {...this.getCheckboxGroupFilterProps('strategy')} />
				</Collapse.Panel>
				<Collapse.Panel header={this.getCollapseHeader('saleStrategy', 'Strategia di vendita')} key="saleStrategy">
					<Checkbox.Group {...this.getCheckboxGroupFilterProps('saleStrategy')} />
				</Collapse.Panel>
				<Collapse.Panel header={this.getCollapseHeader('destination', 'Destinazione')} key="destination">
					<Checkbox>Tutti</Checkbox><br/>
					<Checkbox.Group {...this.getCheckboxGroupFilterProps('destination')} />
				</Collapse.Panel>
			</Collapse>
		) }
		</QueueAnim>);
	}
}

export { FilterPanel };
